import React from 'react'
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert,
} from '@mui/material'

const NotificationPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        通知
      </Typography>
      
      <Card>
        <CardContent>
          <Alert severity="info">
            通知機能は実装中です。通知一覧と設定がここに表示されます。
          </Alert>
        </CardContent>
      </Card>
    </Box>
  )
}

export default NotificationPage